// Polyfill Promise.withResolvers (ES2024) for older browsers — e.g. Chrome <119
// on macOS 10.15 Catalina. pdfjs-dist (via react-pdf) calls it without a fallback,
// so without this the F24 PDF preview crashes with "Promise.withResolvers is not a
// function". Must run before any import that may use it. No-op on modern browsers.
import 'core-js/es/promise/with-resolvers';
import './locales/i18n';
import * as Sentry from '@sentry/react';
import BigNumber from 'bignumber.js';
import { StrictMode, useEffect } from 'react';
import { I18nProvider as AriaI18nProvider } from 'react-aria';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import App from './App';
import HubSpot from './components/@sibill-components/hubspot';
import i18n from './locales/i18n';
import '~/theme/variables.scss';
import '~/theme/global.scss';

BigNumber.set({ STRICT: false });

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
      Sentry.browserSessionIntegration(),
    ],
    tracesSampleRate: 0.2,
  });
  Sentry.setContext('Client Settings', {
    'Browser Language': navigator.language,
    Timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    'Client Height': document.documentElement.clientHeight,
    'Client Width': document.documentElement.clientWidth,
  });
}

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <I18nextProvider i18n={i18n}>
      <AriaI18nProvider locale={i18n.language}>
        <StrictMode>
          <App />
        </StrictMode>
        <HubSpot />
      </AriaI18nProvider>
    </I18nextProvider>,
  );
}
